export default {
  event: {
    default: 'Salon | Salons',
    title: 'Les salons',
    list: {
      page_title: 'Liste des salons',
      part: 'Liste des salons'
    },
    edit: {
      page_title: 'Modification du salon :'
    },
    create: {
      page_title: 'Création d\'un salon'
    },
    show: {
      page_title: 'Salon :'
    },
    map: {
      localisation: 'Situation sur la carte',
      show_on: 'Voir sur la carte'
    },
    no_event: 'aucun salon'
  }
}
